import { render, staticRenderFns } from "./TireSpecifications.vue?vue&type=template&id=1407b369"
import script from "./TireSpecifications.vue?vue&type=script&lang=ts"
export * from "./TireSpecifications.vue?vue&type=script&lang=ts"
import style0 from "./TireSpecifications.vue?vue&type=style&index=0&id=1407b369&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports